import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { IonicModule } from '@ionic/angular';
import { provideAuth0 } from '@auth0/auth0-angular';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    // IonicModule.forRoot() global config (mode: 'md') — individual ion-* components are
    // imported directly into each standalone component's own `imports` array (see e.g.
    // TokensPage), this only carries the app-wide config that has no standalone equivalent.
    importProvidersFrom(IonicModule.forRoot({ mode: 'md' })),
    provideHttpClient(withXhr(), withInterceptors([authInterceptor])),
    // Same Auth0 tenant/audience as Portal-SPA for SSO — own clientId (see
    // environment.ts TODO: register a dedicated Auth0 SPA client).
    provideAuth0({
      domain: environment.auth0.domain,
      clientId: environment.auth0.clientId,
      useRefreshTokens: true,
      useRefreshTokensFallback: true,
      authorizationParams: {
        redirect_uri: window.location.origin + '/callback',
        audience: environment.auth0.audience,
        scope: 'openid profile email offline_access',
      },
    }),
    // i18n
    importProvidersFrom(TranslateModule.forRoot({
      fallbackLang: 'de',
    })),
    ...provideTranslateHttpLoader({ prefix: 'assets/translations/', suffix: '.json' }),
  ],
};
